import { SafeAny } from '@models/common';
import axios from 'axios';

export const downloadPdf = ({
  pdfURL,
  fileName,
}: {
  pdfURL: string;
  fileName: string;
}): Promise<SafeAny> => {
  return axios({
    url: pdfURL,
    method: 'GET',
    responseType: 'blob',
  }).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  });
};
